import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { useAppStateContext } from 'src/AppState/AppState';
import { CasinoPage } from 'src/domains/casino/pages/CasinoPage';

export const CasinoPageContent = observer('CasinoPageContent', (): React.ReactElement => {
    const { appCasinoState } = useAppStateContext();
    const { casinoTabParam } = appCasinoState.redirectState;
    return (
        <>
            {casinoTabParam === 'casino' && <CasinoPage collection='casino' />}
            {casinoTabParam === 'live-casino' && <CasinoPage collection='live-casino' />}
            {casinoTabParam === 'virtuals' && <CasinoPage collection='virtuals' />}
        </>
    );
});
